@if (queryProperties$ | async; as queryProperties) {
  <div class="flex flex-row mt-2">
    @for (queryProperty of queryProperties; track queryProperty; let first = $first) {
      <soft-chip [ngClass]="first ? '' : 'ml-2'">
        <div class="flex items-center gap-2">
          <strong>{{ queryProperty?.label }}</strong>
          @if (queryProperty?.type === 'text') {
            <span class="text-sm">{{ queryProperty?.value }}</span>
          } @else {
            <span class="text-sm">{{ $safeNavigationMigration(queryProperty?.value) | date: 'dd.MM.yyyy' }}</span>
          }
        </div>
      </soft-chip>
    }
  </div>
}

@if ((loading$ | async) && ((workNotes$ | async)?.length ?? 0) < 1) {
  <div class="flex flex-row justify-center p-5 mt-5">
    <soft-loading-spinner class="spin"></soft-loading-spinner>
  </div>
} @else {
  @if (workNotes$ | async; as workNotes) {
    @if ((workNotes?.length ?? 0) < 1) {
      <div class="flex flex-col items-center pt-5 empty-content">
        <i class="fa-regular fa-clipboard-check fa-3x mb-1" style="opacity: 0.5"></i>
        <span class="mt-3">{{ '#WORK_NOTE.LIST.EMPTY' | translate }}</span>
      </div>
    } @else {
      @for (workNote of workNotes$ | async; track workNote) {
        <div class="flex flex-col">
          <lib-work-note-card
            [workNote]="workNote"
            (tapped)="openDetails($event)"
          ></lib-work-note-card>
        </div>
      }
    }
  }
}
